if (!customElements.get('dx-countdown')) {
  customElements.define(
    'dx-countdown',
    class DxCountdown extends HTMLElement {
      connectedCallback() {
        this.values = {};
        this.querySelectorAll('[data-unit]').forEach((el) => {
          this.values[el.dataset.unit] = el;
        });

        const end = parseInt(this.dataset.end, 10);
        this.end = Number.isFinite(end) ? end * 1000 : null;
        this.loop = this.dataset.loop === 'true';
        this.cycle = Math.max(1, parseFloat(this.dataset.cycleHours) || 24) * 3600000;

        // Mode durée (ex. panier réservé 10 min) : la fin est gardée pour la visite (sessionStorage).
        const duration = parseInt(this.dataset.duration, 10);
        if (Number.isFinite(duration) && duration > 0) {
          this.duration = duration * 1000;
          this.storageKey = this.dataset.storageKey || 'dx-countdown';
          this.end = this.readEnd() || this.restart();
        }

        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      readEnd() {
        try {
          const saved = parseInt(sessionStorage.getItem(this.storageKey), 10);
          return Number.isFinite(saved) ? saved : null;
        } catch (e) {
          return null;
        }
      }

      restart() {
        this.end = Date.now() + this.duration;
        try {
          sessionStorage.setItem(this.storageKey, String(this.end));
        } catch (e) {
          // Stockage indisponible (navigation privée) : le minuteur repart à chaque page.
        }
        return this.end;
      }

      remaining() {
        const now = Date.now();
        if (this.end && now < this.end) return this.end - now;
        if (this.duration) return this.loop ? this.restart() - now : 0;
        if (!this.loop) return 0;

        // Sans date de fin, les cycles partent de minuit (heure du visiteur).
        let anchor = this.end;
        if (!anchor) {
          const midnight = new Date();
          midnight.setHours(0, 0, 0, 0);
          anchor = midnight.getTime();
        }
        return this.cycle - ((now - anchor) % this.cycle);
      }

      tick() {
        const ms = this.remaining();
        if (ms <= 0 && this.dataset.hideWhenDone === 'true') {
          this.hidden = true;
          clearInterval(this.timer);
          return;
        }

        const total = Math.max(0, Math.floor(ms / 1000));
        // Format « hms » : pas de jours, les heures cumulent tout (ex. 49:05:12).
        // Format « ms » : les minutes cumulent tout (ex. 10:00).
        const withDays = this.dataset.format !== 'hms' && this.dataset.format !== 'ms';
        const parts = {
          days: Math.floor(total / 86400),
          hours: withDays ? Math.floor((total % 86400) / 3600) : Math.floor(total / 3600),
          minutes: this.dataset.format === 'ms' ? Math.floor(total / 60) : Math.floor((total % 3600) / 60),
          seconds: total % 60,
        };

        for (const [unit, value] of Object.entries(parts)) {
          if (this.values[unit]) this.values[unit].textContent = String(value).padStart(2, '0');
        }
      }
    }
  );
}
